export enum NewType {
    widget_only,
    section_only,
    widget_or_section
}

export interface NewOption {
    type: NewType;
    tag: any | null;
}